"use client";

import { useNewScheduleLabel } from "@repo/ui/components/common/ScheduleChangeTime/useNewScheduleLabel";
import { cn } from "@repo/ui/lib/utils";

interface ScheduleChangeTimeProps {
  original: string;
  // Airport code shown before the original time, e.g. "SCL 10:30".
  code?: string;
  // New (ETD/ETA) time. When absent the original is rendered as a normal time.
  updated?: string | null;
  align?: "left" | "right";
  className?: string;
}

// Original time struck through, then the "new schedule" label and the new time below it.
export default function ScheduleChangeTime({
  original,
  code,
  updated,
  align = "left",
  className,
}: Readonly<ScheduleChangeTimeProps>) {
  const label = useNewScheduleLabel();

  if (!updated) {
    return <p className={cn("text-brand-cyan", className)}>{original}</p>;
  }

  return (
    <div
      className={cn("flex flex-col", align === "right" ? "items-end" : "items-start")}
      data-testid="schedule-change-time"
    >
      <p className={cn("text-brand-black-60 line-through", className)}>
        {code ? `${code} ` : ""}
        {original}
      </p>
      <p className="text-brand-black-60 text-xs italic">{label}</p>
      <p className={cn("text-brand-cyan", className)}>{updated}</p>
    </div>
  );
}
